module.exports = __webpack_public_path__ + "media/images/messaging-e86e58b0d1fab165d981fdd5688d6a51.svg";